import { render, staticRenderFns } from "./block-clock.vue?vue&type=template&id=7065f626&scoped=true"
import script from "./block-clock.vue?vue&type=script&lang=js"
export * from "./block-clock.vue?vue&type=script&lang=js"
import style0 from "./block-clock.vue?vue&type=style&index=0&id=7065f626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065f626",
  null
  
)

export default component.exports